<ng-container *ngIf="!loading && count">
  <nav aria-label="{{resource}} navigation" *ngIf="!showing_all; else all">
    <ul class="pagination">
      <li class="page-item">
        <a class="page-link" [class.disabled]="page === 1" (click)="prev()" tabindex="-1" aria-label="Previous">
          <span class="desktop-btn" aria-hidden="true">&lt; Prev</span>
          <span class="mobile-btn" aria-hidden="true">&lt; </span>
        </a>
      </li>
      <li class="page-item" *ngFor="let pg of getPageList(pages.length, page, 7)" [class.active]="pg === page">
        <a class="page-link" *ngIf="pg" (click)="goto(pg)">{{pg}}</a>
        <a class="page-link" *ngIf="!pg">...</a>
      </li>
      <li class="page-item">
        <a class="page-link" [class.disabled]="page === pages.length" (click)="next()" aria-label="Next">
          <span class="desktop-btn" aria-hidden="true">Next &gt;</span>
          <span class="mobile-btn" aria-hidden="true">&gt; </span>
        </a>
      </li>
    </ul>
  </nav>
</ng-container>

<ng-template #all>
  <p *ngIf="count > 1">Showing all {{count}} {{resource}}</p>
</ng-template>
